module.exports = __webpack_public_path__ + "img/alex.a73cc85b.jpg";